import React from "react";
import { Link } from "react-router-dom";
import { useCart } from "@/context/CartContext";
import { imgUrl } from "@/lib/api";

const CartDrawer = () => {
  const { items, open, setOpen, subtotal, shipping, total, remove, setQty } = useCart();

  return (
    <>
      <div
        onClick={() => setOpen(false)}
        className={`fixed inset-0 z-50 bg-ink/30 backdrop-blur-[2px] transition-opacity duration-300 ${open ? "opacity-100" : "opacity-0 pointer-events-none"}`}
        data-testid="cart-backdrop"
      />
      <aside
        className={`fixed top-0 right-0 z-[55] h-full w-full sm:w-[440px] bg-ground flex flex-col transition-transform duration-500 ${open ? "translate-x-0" : "translate-x-full"}`}
        style={{ borderLeft: "1px solid var(--stone)" }}
        data-testid="cart-drawer"
      >
        <div className="p-6 hairline-b flex items-center justify-between">
          <span className="serif text-2xl">Your cart</span>
          <button className="nav-item" onClick={() => setOpen(false)} data-testid="cart-close-btn">Close</button>
        </div>

        <div className="flex-1 overflow-y-auto p-6 space-y-6">
          {items.length === 0 && (
            <p className="text-sm text-ink/60" data-testid="cart-empty">Your cart is empty — pick a piece from the shop.</p>
          )}
          {items.map((i) => (
            <div key={i.key} className="flex gap-4 items-start" data-testid={`cart-item-${i.slug}`}>
              <img src={imgUrl(i.image)} alt={i.name} className="w-20 h-24 object-cover" />
              <div className="flex-1">
                <div className="serif text-lg leading-tight">{i.name}</div>
                <div className="text-xs text-ink/60 mt-1">
                  Size {i.size}{i.is_pair ? " · Twinning pair" : ""}
                </div>
                <div className="mt-2 flex items-center gap-3 text-sm">
                  <button className="hairline w-6 h-6 flex items-center justify-center rounded-full" onClick={() => setQty(i.key, i.qty - 1)} data-testid={`cart-dec-${i.slug}`}>–</button>
                  <span className="w-6 text-center">{i.qty}</span>
                  <button className="hairline w-6 h-6 flex items-center justify-center rounded-full" onClick={() => setQty(i.key, i.qty + 1)} data-testid={`cart-inc-${i.slug}`}>+</button>
                </div>
              </div>
              <div className="text-right">
                <div className="text-sm">₹{(i.unit_price * i.qty).toLocaleString("en-IN")}</div>
                <button onClick={() => remove(i.key)} className="text-xs mt-2 text-ink/60 hover:text-accent" data-testid={`cart-remove-${i.slug}`}>Remove</button>
              </div>
            </div>
          ))}
        </div>

        <div className="p-6 hairline-t space-y-3">
          <div className="flex justify-between text-sm"><span>Subtotal</span><span>₹{subtotal.toLocaleString("en-IN")}</span></div>
          <div className="flex justify-between text-sm text-ink/70"><span>Shipping</span><span>{shipping === 0 ? "Free" : `₹${shipping}`}</span></div>
          <div className="flex justify-between text-base"><span>Total</span><span className="serif text-xl">₹{total.toLocaleString("en-IN")}</span></div>
          <Link
            to="/checkout"
            onClick={() => setOpen(false)}
            className={`btn-solid w-full mt-2 ${items.length === 0 ? "opacity-40 pointer-events-none" : ""}`}
            data-testid="cart-checkout-btn"
          >
            Checkout
          </Link>
        </div>
      </aside>
    </>
  );
};

export default CartDrawer;
